import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { styled, FormControlLabel, Checkbox } from '@mui/material';
import _merge from 'lodash/merge';
import React__default from 'react';
import brandclub_colors from '../../colors/brandclubColors.js';

const BpIcon = styled('span')(() => ({
    borderRadius: 3,
    width: 22,
    height: 22,
    border: '1px solid #afb0b1',
    backgroundColor: '#fff',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
    },
}));
const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#181d56',
    border: '1px solid #181d56',
    '&:before': {
        display: 'block',
        width: 22,
        height: 22,
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22'%3E%3Cg data-name='Group 3355'%3E%3Cg data-name='Check box'%3E%3Cg data-name='Rectangle 2350' style='fill:%23181d56;stroke:%23181d56'%3E%3Crect width='22' height='22' rx='3' style='stroke:none'/%3E%3Crect x='.5' y='.5' width='21' height='21' rx='2.5' style='fill:none'/%3E%3C/g%3E%3C/g%3E%3Cpath data-name='check (1)' d='M4.025 8.388a.563.563 0 0 1-.4-.165L.166 4.763a.565.565 0 1 1 .8-.8l3.06 3.06L10.545.5a.565.565 0 0 1 .8.8L4.424 8.222a.563.563 0 0 1-.399.166zm0 0' transform='translate(4.987 6.157)' style='fill:%23fff;stroke:%23fff;stroke-width:.5px'/%3E%3C/g%3E%3C/svg%3E")`,
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
    },
});
// Inspired by blueprintjs
function BpCheckbox(props) {
    return (React__default.createElement(Checkbox, Object.assign({ sx: {
            '&:hover': { bgcolor: 'transparent' },
        }, disableRipple: true, color: "default", checkedIcon: React__default.createElement(BpCheckedIcon, null), icon: React__default.createElement(BpIcon, null), inputProps: { 'aria-label': 'Checkbox demo' } }, props)));
}
/**
 * - wraps checkbox & label
 * - use FormControl in parent component if required
 */
const AppCheckbox = (props) => {
    const { error, label, hideLabel, checkboxProps } = props, rest = __rest(props, ["error", "label", "hideLabel", "checkboxProps"]);
    const _a = checkboxProps || {}, { sx, className } = _a, restCheckboxProps = __rest(_a, ["sx", "className"]);
    const defaultSx = {
        color: error ? brandclub_colors.redBright : brandclub_colors.gray5,
    };
    const mergedSx = _merge(defaultSx, sx);
    const CheckBoxComponent = (React__default.createElement(BpCheckbox, Object.assign({ size: "medium", sx: mergedSx, disableRipple: true, className: className }, restCheckboxProps)));
    if (hideLabel) {
        return CheckBoxComponent;
    }
    return (React__default.createElement(FormControlLabel, Object.assign({ label: label, className: `${error ? 'checkbox-error' : ''}`, control: CheckBoxComponent }, rest)));
};

export { AppCheckbox };
//# sourceMappingURL=index.js.map
